import React from 'react';
import { Box, Grid } from '@mui/material';
import { PageSubTitle } from 'components/Structure';
import { ThemeTypography, CardIllustration, CardContainer, ActionLink } from 'designSystem';
import { AvailableSizes, BackgroundTypes, IllustrationTypes } from 'types/enums';

interface Props {
  title: string;
  description: string;
  fullWidth?: boolean;
  /** @default 'Contact us' */
  actionText?: string;
  onClick: () => void;
}

const InspirationContactBlock: React.FC<Props> = ({
  title,
  description,
  fullWidth = false,
  actionText = 'Contact us',
  onClick,
}) => {
  return (
    <Box mt={3}>
      <Box>
        <PageSubTitle title="Inspiration" mb={2} />
      </Box>
      <Box display="flex" gap={3} justifyContent="space-between" data-cy="inspiration-cards">
        <Grid container>
          <Grid item xs={12} md={fullWidth ? 12 : 7}>
            <CardContainer
              title={title}
              size={AvailableSizes.SMALL}
              background={BackgroundTypes.RECTANGLE}
              flex={1}
              renderIllustration={undefined}
              padding={undefined}
              loading={undefined}
            >
              <ThemeTypography variant="BODY_LARGE">{description}</ThemeTypography>
              <Box display="flex" justifyContent="space-between" mt="auto">
                <CardIllustration image={IllustrationTypes.ROCKET} width={160} ml={-3} mb={-5} />
                <Box display="flex" justifyContent="end" mt="auto" pt={2}>
                  <ActionLink
                    onClick={onClick}
                    target="_blank"
                    data-cy="inspiration-card-contact-link"
                  >
                    {actionText}
                  </ActionLink>
                </Box>
              </Box>
            </CardContainer>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default InspirationContactBlock;
